// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RzVWT","field":"styles_field__2q0Ny","fieldCol":"styles_fieldCol__13b0w","diffCol":"styles_diffCol__36zBD","diff":"styles_diff___Rmr0"};